import React, { Component,useEffect,useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import Select from "react-select";
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import DataTable,{defaultThemes} from 'react-data-table-component';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import HTMLParserComponent from "../HTMLParserComponent.js"

import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import '../preloading.css';

import Pagination from '../Pagination/Paginations.js';
import EntriesSelector from '../Pagination/EntriesSelector';
import useSortData from "../Pagination/SortData";
// import "../../components/toast.css";




import {
	statisticsAction,
	statisticsCloseAction
} from '../../actions/settingsAction.js';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const HrExchangeShift = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;

	// function getDate() {
	// 	const today = new Date();
	// 	const month = today.getMonth() + 1;
	// 	const year = today.getFullYear();
	// 	const date = today.getDate();
	// 	return `${year}-${month}-${date}`;
	//   }

	const today = new Date().toISOString().split("T")[0];


	const [user, setUser] = useState({
        start_date: today,
        department:"",
    })



	

	
	const history = useHistory();
	const [data, setData]= useState([]);
	const [dataval, setdataval]= useState([]);
	const [attnlist, setattnlist]= useState([]);
    const [isVisible, setIsVisible] = useState(false);
	const [urlres, setUrlRes] = useState(false);
	const [style1,setStyle1]=useState(false);
	const [records, setRecords] = useState([]);
	const [loading, setLoading] = useState(false);

	const { sortConfig, sortData, handleSort } = useSortData();


    const handelInput = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        console.log(name, value)
        setUser({ ...user, [name]: value });

    
    }

    const [shiftcode,setShiftCodeValue]= useState("");
	const [officeshift,setOfficeShift]= useState([]);

	const handleShift = (event) => {
	const value = event.target.value;
	setShiftCodeValue(value);

	
  };


  		const [searchTerm, setSearchTerm] = useState("");
		const [currentPage, setCurrentPage] = useState(1);
		const [entriesPerPage,setEntriesPerPage]=useState(10);
		let filteredItems = records.filter((item) =>
			`${item.from_emp.toLowerCase()}${item.to_emp.toLowerCase()}`.includes(searchTerm.toLowerCase())
		 
		);
		const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
		const indexOfLast = currentPage * entriesPerPage;
		const indexOfFirst = indexOfLast - entriesPerPage;
		// const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);
		const sortedItems = sortData(filteredItems);
const filteredData = sortedItems.slice(indexOfFirst, indexOfLast);
		
	  const handleSearch = (event) => {
		//console.log(event.target.value);
		 setSearchTerm(event.target.value);
	  };


	   const clearInput = () => {
		setSearchTerm("");
	  };
	 
	
	





      const handleDepartment = async () => {
	  
        axios.get(API_BASE_URL +'/showdepartment', { headers : {
               'Content-Type': 'application/json',
               Authorization: `Bearer ${localStorage.getItem("authToken")}`
       }})
        .then(res1 => setdataval(res1.data))
        .catch(err => console.log(err))
       };
  
  
       useEffect(() => {
        handleDepartment();
      }, []);







const handleSubmit = async (e) => {
    e.preventDefault();
	setLoading(true);

	// alert(user.start_date);
	// alert(user.department);
    try {
      const response = await axios.post(API_BASE_URL +'/exchange_approval_list',
		{ exchange_date: user.start_date, dept_id: user.department }, 
		{
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}

);
console.log(response.data.exchangeshift);
      setRecords(response.data.exchangeshift); // Assuming the API response contains the records in `response.data`
	  setLoading(false);
	} catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  useEffect(()=> {
	axios.post(API_BASE_URL +'/exchange_approval_list',{exchange_date:''}, {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})

    // .then(response =>console.log(response.data.shiftattendance))
	 .then(response => setRecords(response.data.exchangeshift))
	.catch(err => console.log(err));
},[])




	


			


	const emptyUser={
	shift_code: '',
    attendance_date: '',
    clock_in_date: '',
    clock_in: '',
    clock_out_date: '',
	clock_out: '',
	employee_id:'',
	user_id:'',
	old_clock_in_date: '',
	old_clock_in: '',
	old_clock_out_date: '',
	old_clock_out: '',
	old_shift_code: '',
	attendance_history:'',
	}



const [modalData, setModalData] = useState({
    shift_code: '',
    attendance_date: '',
    clock_in_date: '',
    clock_in: '',
    clock_out_date: '',
	clock_out: '',
	employee_id:'',
	user_id:'',
	old_clock_in_date: '',
	old_clock_in: '',
	old_clock_out_date: '',
	old_clock_out: '',
	old_shift_code: '',
	attendance_history:'',
});

const handelModalInput = (e) => {
    const { name, value } = e.target;
    setModalData({ ...modalData, [name]: value });
};

	const handleUpdate = async (user_id,attn_date) => {

		// console.log(user_id);
		// console.log(attn_date);

		axios.get(API_BASE_URL + '/read_shift_data/' + user_id +'/'+attn_date, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		   
			
			.then(res1 => setModalData(res1.data.readshift))
			.then(res2=>setattnlist(res2.data.readshift.attn_list))
			.catch(err => console.log(err))
	};

	const handleDecision = async (action, exchange_id) => {

		
	const confirmMessage =
		action === "approve"
			? "Are you sure you want to approve this shift exchange?"
			: "Are you sure you want to reject this shift exchange?";

	if (!window.confirm(confirmMessage)) return;

	const endpoint =
		action === "approve" ? "/approveShiftExchange" : "/rejectShiftExchange";

	try {
		const response = await axios.get(API_BASE_URL + endpoint+'/'+exchange_id, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		});

		if (response.data.status === "success") {
			
			toast.success(response.data.message, {
						 position: "bottom-right",
						autoClose: 5000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: "colored",
						style: {
							backgroundColor: "#28a745", // ✅ Bootstrap Success Green
							color: "#fff",              // White text
							fontWeight: "500"
						},
						});
			setTimeout(() => {
      window.location.href = "/shift-exchanges";
    }, 1500);
		} else {
			toast.error(response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				theme: "colored",
			});
			setTimeout(() => {
      window.location.href = "/shift-exchanges";
    }, 1500);
		}
	} catch (error) {
		toast.error(error.response?.data?.message || "An error occurred", {
			position: "bottom-right",
			autoClose: 5000,
			theme: "colored",
		});
	}
};



	const handleEditSubmit = (e) => {

		e.preventDefault();

		console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();
		axios.post(API_BASE_URL + '/update_shift_and_attendance', {shift_date : modalData.attendance_date, shift_code: modalData.shift_code, clock_in_date: modalData.clock_in_date,clock_in: modalData.clock_in,clock_out_date: modalData.clock_out_date,clock_out : modalData.clock_out, employee_id: modalData.employee_id,user_id: modalData.user_id,old_clock_in_date: modalData.old_clock_in_date,old_clock_in: modalData.old_clock_in,old_clock_out_date: modalData.old_clock_out_date,
	old_clock_out: modalData.old_clock_out,
	old_shift_code: modalData.old_shift_code,attn_history: modalData.attendance_history }, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
			// console.log(response.data);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 'success') {
				toast.success(response.data.result, {
				position: "bottom-right",
				autoClose: 3000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				style: {
					backgroundColor: "#4CAF50 !important;", // ✅ success green
					color: "#fff",
					fontWeight: "bold",
					borderRadius: "8px",
					boxShadow: "0 2px 8px rgba(0,0,0,0.2)"
				},
			});

				const timeout = setTimeout(() => {
					window.location.reload(); // Reload the current page
				}, 5000); // Refresh after 5 seconds

				return () => {
					clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				};

			} else if (status == 'error') {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 'error') {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};




	const departmentOptions = [
		{ value: "", label: "All Department" },
		...dataval.map(o => ({ value: o.department_id, label: o.department_name }))
	];

	const selectFieldStyles = {
		control: (base) => ({
			...base,
			minHeight: "38px",
			height: "38px",
			borderRadius: "4px",
			borderColor: "#ced4da",
			boxShadow: "none",
			fontSize: "14px",
			padding: "0 4px",
			"&:hover": { borderColor: "#b3b3b3" }
		}),
		valueContainer: (base) => ({ ...base, height: "38px", padding: "0 6px" }),
		input: (base) => ({ ...base, margin: "0px", padding: "0px" }),
		indicatorsContainer: (base) => ({ ...base, height: "38px" }),
		menu: (base) => ({ ...base, borderRadius: "4px", zIndex: 9999 }),
		option: (base, state) => ({
			...base,
			fontSize: "14px",
			padding: "6px 10px",
			backgroundColor: state.isFocused ? "#f8f9fa" : "white",
			color: "#333"
		})
	};

	const columns = [
  { label: "Incharage", key: "incharge_info", sortable: true },
  { label: "From Employee", key: "from_emp", sortable: true },
  { label: "To Employee", key: "to_emp", sortable: true },
  { label: "Shift Date", key: "shift_date", sortable: true },
  { label: "From - To", key: "shift_exchange", sortable: true },
  { label: "Hr Approval", key: "puncapproval_statush_out", sortable: true }
];



	return (
		<>
			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

						<ToastContainer/>
							

						</div>


						
					</div>


                    <div className="section-body mt-3">
					<div className="container-fluid">
						<div className="row clearfix">
							<div className="col-md-12">
								<div className="card">
									<div className="card-header">
										<h3 className="card-title d-flex align-items-center" style={{ color: "#1d3a8a", fontWeight: 600 }}>
											<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16" fill="#1d3a8a" style={{ marginRight: "8px", verticalAlign: "-3px" }}>
												<path fillRule="evenodd" d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5m14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5"/>
											</svg>
											Exchange Shift
										</h3>
									</div>
									<div className="card-body">
										 <form onSubmit={handleSubmit}> 

                                            <div class="row align-items-end">

											<div className="col-md-3 col-sm-6">
												<div className="form-group mb-2">
												<label className="form-label">From Date</label>
								<DatePicker
																  selected={user.start_date ? new Date(user.start_date) : null}
																  onChange={(date) => {
																	const value = date
																	  ? date.toISOString().split("T")[0] // YYYY-MM-DD
																	  : "";

																	setUser(prev => ({
																	  ...prev,
																	  start_date: value,
																	}));
																  }}
																  dateFormat="dd-MM-yyyy"
																  placeholderText="Select Start Date"
																  className="form-control"
																   showMonthDropdown
																	showYearDropdown
																	dropdownMode="select"
																/>

												</div>
											</div>





                                    <div className="col-md-3 col-sm-6">
									<div className="form-group mb-2">
									<label className="form-label">Department</label>
									<Select
										name="department"
										isSearchable={true}
										placeholder="Select Department"
										options={departmentOptions}
										value={departmentOptions.find(opt => opt.value == user.department) || null}
										onChange={(selected) => setUser(prev => ({ ...prev, department: selected?.value ?? "" }))}
										styles={selectFieldStyles}
										classNamePrefix="react-select"
									/>
									</div>
                                    </div>







                                <div className="col-md-4 col-sm-6">
									<div className="form-group mb-2">

                                <button type="submit" className="btn btn-primary">
								GET
							</button>

							

							
                            </div>
                            </div>



                            </div>

                            
                               

                                           


										
	
										
											
										 </form>
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>








					<div className="section-body">
						<div className="container-fluid">
							<div className="tab-content">
								<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
									<div className="card">

										<div className="card-header">
											<div
  className="card-options"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "12px",
  }}
>
  <EntriesSelector
    entriesPerPage={entriesPerPage}
    setEntriesPerPage={setEntriesPerPage}
    setCurrentPage={setCurrentPage}
  />

  {/* 🔽 SEARCH BOX WRAPPER */}
  <div style={{ position: "relative", width: "200px" }}>
    <input
      type="text"
      className="form-control form-control-sm"
      placeholder="Search"
      value={searchTerm}
      onChange={(e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
      }}
      style={{
        width: "100%",
        height: "30px",
        fontSize: "13px",
        borderRadius: "4px",
        paddingRight: "28px", // ✅ space for X
      }}
    />

    {searchTerm.length > 0 && (
      <span
        onClick={clearInput}
        style={{
          position: "absolute",
          right: "8px",        // ✅ INSIDE input
          top: "50%",          // ✅ vertically centered
          transform: "translateY(-50%)",
          cursor: "pointer",
          color: "#aaa",
          fontSize: "16px",
          userSelect: "none",
        }}
      >
        ✖
      </span>
    )}
  </div>
</div>
										</div>


{loading && (
											<div className="card-body">
											<div class="d-flex justify-content-center">
       <div class="spinner"></div>
	   </div>
	   </div>
      )}

{!loading && (
										<div className="card-body">
										
											<div className="table-responsive sticky-table-wrap" style={{ maxHeight: "60vh", overflowY: "auto" }}>



			<table className="table table-hover table-striped table-vcenter text-nowrap mb-0 sticky-table">
													<thead style={{ position: "sticky", top: 0, zIndex: 1 }}>
														<tr>
                                                           {columns.map((col) => (
      <th
        key={col.key}
        onClick={col.sortable ? () => handleSort(col.key) : null}
        style={{ cursor: col.sortable ? "pointer" : "default", backgroundColor: "#fff" }}
      >
        {col.label}
       {col.sortable && (
      sortConfig.key === col.key
        ? (sortConfig.direction === "asc" ? " ▲" : " ▼")
        : " ⇅"   // <-- DEFAULT SORT ICON
    )}
		  </th>
    ))}
															
															
														</tr>
													</thead>
													<tbody>
														{/* {console.log(records)} */}
													{records.length > 0 ? (
															filteredData.map((record) => {

                                                                let status;

                                                                if(record.approval_status==0)
                                                                {
                                                                    	status = (
                                                                            <>
                                                                                    <button
                                                                                        className="btn btn-primary"
                                                                                         onClick={() => handleDecision("approve", record.exchange_id)}
                                                                                    >
                                                                                        Approve
                                                                                    </button>

                                                                                    <button
                                                                                        className="btn btn-primary"
                                                                                         onClick={() => handleDecision("reject", record.exchange_id)}
                                                                                    >
                                                                                        Reject
                                                                                    </button>

                                                                                   </> 
                                                                                    );
                                                                }
                                                                else if(record.approval_status==1)
                                                                {
                                                                    status=record.hr_status;
                                                                }

															

															return(
															<tr key={record.incharge_info}>
																
																<td>{record.incharge_info}</td>
																<td>{record.from_emp}</td>
																<td>{record.to_emp}</td>
																<td>{record.shift_date}</td>
                                                                <td>{record.shift_exchange}</td>
                                                                <td>{record.approval_status}</td>
																<td>{status}</td>
																

															</tr>
															)
})
														) : (
															<tr>
															<td colSpan="6" style={{ color: 'red', textAlign: 'center',fontWeight: "bold" }}>No records found</td>
															</tr>
														)}

											
													</tbody>
												</table>
											</div>
										
												<Pagination
												currentPage={currentPage}
												totalPages={totalPages}
												onPageChange={setCurrentPage}
												/>	
								

										</div> 
)
}
									</div>
								</div>
	
							
							</div>
						</div>
					</div>

				</div>
			</div> 

										
			


			
			


			

		</>
	);
}

const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(HrExchangeShift);